import apiClient from './apiClient';

class LookupService {
    static getLookup(name) {
        return apiClient.get(`/Lookup/${name}`);
    }
    static getLookupAvailability(name, value) {
        return apiClient.get(`/LookupAvailability/${name}`, { params: { value } });
    }
    static getLookupCountry() {
        return apiClient.get('/Location/Country/');
    }
    static getLookupState(countryID) {
        return apiClient.get(`/Location/Country/${countryID}`);
    }
    static getLookupLandingPages() {
        return apiClient.get('/LandingPages');
    }
}

export default LookupService;
